<template>
  <div class="form-group lm-text-area" v-if="showComponent" :class="{ row : isOnModeLabelOnLeft }">
    <label
      :for="idComputed"
      :title="titleComputed"
      :class=" {'col-sm-2': isOnModeLabelOnLeft, 'col-form-label': isOnModeLabelOnLeft }"
      class="text-truncate"
      v-if="label"
      >{{label}} <small v-if="required">*</small> </label>
    <font-awesome-icon
      id="font-awesome-icon-edit"
      icon="edit"
      size="sm"
      class="clickable float-right mt-1"
      :class="{ 'ml-2': help }"
      v-if="showEditButton"
      @click="$emit('edit-button-clicked')"
      />
    <font-awesome-icon
      icon="question-circle"
      size="sm"
      class="clickable float-right mt-1"
      v-if="help"
      v-b-tooltip.hover="help"
    />
    <lm-dropdown
      v-if="isEditableByPickedUser"
      class="float-right"
      :tooltip="!disableEditors ? 'Selecciona quién edita este campo' : null"
      template="user-list"
      @input="$emit('editor-change', $event)"
      :value="collaborator"
      :disabled="disableEditors"
      closeAfterPick
    >
      <div class="d-flex align-items-center gap-2">
        {{ collaborator.name || '' }}
        <a-icon type="edit" v-if="!disableEditors" />
      </div>
    </lm-dropdown>
    <div :class="{ 'col-sm-10': isOnModeLabelOnLeft }">
      <textarea
        :autofocus="autofocus"
        ref="textarea"
        :value="value"
        @focusout="validateOnfocusOutMethod"
        @input="$emit('input', $event.target.value)"
        :class="{'is-invalid': v.$error}"
        :readonly="readonly"
        :placeholder="placeholder"
        class="form-control"
        :id="idComputed"
        :rows="rows"
        :cols="cols"
        :disabled="disabled"
        :maxlength="maxLength"
        />
        <p class="invalid-feedback" v-if="v.required === false"> {{ $t('field_required')}} </p>
        <p class="invalid-feedback" v-if="v.maxLength === false"> {{ $tc('character_max_length', maxLengthCharactersAllowed )}} </p>
        <p id="lm-text-area-was-max-length-reached" v-if="wasMaxLengthReached"> {{ $t('max_length_reached' )}} </p>
        <p class="invalid-feedback" v-if="v.sameAs !== undefined && !v.sameAs"> {{ $t('field_same_as') + labelOfFieldUsedForsameAsValidation }}</p>
        <LmVoiceRecognition
          class="mt-2"
          :value="value"
          :enableVoiceRecognition="enableVoiceRecognition"
          @onVoiceRecognitionResult="onVoiceRecognitionResult"
        />
    </div>
  </div>
</template>

<script>
import lmInputMixin from '@/mixins/lmInputMixin.js'
import LmVoiceRecognition from '@/components/form/elements/LmVoiceRecognition'

export default {
  mixins: [lmInputMixin],
  components: {
    LmVoiceRecognition
  },
  props: {
    rows: {
      type: String,
      default: '3'
    },
    cols: {
      type: String,
      default: '20'
    },
    maxLength: {
      type: Number,
      default: 512
    },
    enableVoiceRecognition: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onVoiceRecognitionResult (newValue) {
      this.$emit('input', newValue) // Añadir el texto reconocido al texto existente
    }
  }
}
</script>
